import React, { useContext, useState, useEffect } from 'react';
import tw from 'twin.macro';
import { Icon } from '../icon';
import { ArrowIcon } from 'icons';
import { AppContext } from '../context';

export const GoToTopButton = ({ children, ...props }) => <div {...props}>{children}</div>;

export const ScrollToTopButton = () => {
  const { isDetailPage } = useContext(AppContext);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 400) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <GoToTopButton
      css={[
        tw`fixed bottom-20 sm:top-[95vh] right-[1vw] w-10 h-10 bg-secondary flex justify-center items-center rounded-full cursor-pointer
       translate-x-[200%] transition-transform z-30 drop-shadow-lg z-30`,
        showButton && tw`translate-x-0`,
        isDetailPage && tw`bottom-5 sm:top-[95vh]`,
      ]}
      onClick={goToTop}
    >
      <Icon Type={ArrowIcon} />
    </GoToTopButton>
  );
};
